import BrandsSubscriptionsStore from './schema/BrandsSubscriptionsStore';
import BrandSubscriptionServiceCallState from './schema/BrandSubscriptionServiceCallState';
import { createStore } from 'satcheljs';

const BrandsSubscriptionsDataStore: BrandsSubscriptionsStore = {
    subscriptions: [],
    unsubscribedSubscriptions: [],
    serviceCallState: BrandSubscriptionServiceCallState.NotCalled,
};

const getStore = createStore<BrandsSubscriptionsStore>(
    'brandsSubscriptions',
    BrandsSubscriptionsDataStore
);

export default getStore;
